import {z} from '@hono/zod-openapi';

export const InventoryValueCardSchema = z
  .object({
    id: z.string(),
    articleName: z.string().nullable(),
    catalogueNumber: z.string().nullable(),
    manufacturerName: z.string().nullable(),
    handlingUnit: z.string().nullable(),
    warehouseId: z.string(),
    warehouseName: z.string().nullable(),
    branchId: z.string().nullable(),
    branchName: z.string().nullable(),
    quantity: z.coerce.number().finite().nullable(),
    purchaseValue: z.coerce.number().finite().nullable(),
    sellingValue: z.coerce.number().finite().nullable(),
    stockAgeDays: z.coerce.number().finite().nullable(),
  })
  .openapi('InventoryValueCard');

export type InventoryValueCard = z.infer<typeof InventoryValueCardSchema>;
